import {
  Injectable,
  Component,
  Input,
  OnInit,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { Observable, Subject, takeUntil } from 'rxjs';
import {
  addItemtoMyPurchase,
  updateItemForm,
} from 'src/app/core/store/form.actions';
import { initialState } from 'src/app/core/store/form.reducer';
import PurchaseMode from 'src/app/data/constants/PurchaseMode.json'
import SourcingStatus from 'src/app/data/constants/SourcingStatus.json';
import { itemStatusPopulator } from 'src/app/data/constants/Data';
import {
  ExtendedKeycloakUser,
  IBudgetAllocForm,
  IItemToRequest,
  MyPurchaseForm,
  StoreDropdowns,
  UserInformation,
} from 'src/app/shared/models/app-models';
import { FormHeaderElement } from 'src/app/shared/models/app-models/FormHeaderElementList.model';
import { AddOn, Vendor } from 'src/app/shared/models/database-models';
import _ from 'lodash';
import { ObserversModule } from '@angular/cdk/observers';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { isReadOnly } from 'src/app/core/services/permissions/isReadonly';
import { BudgetAllocation } from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import { AbilityField } from 'src/app/core/services/permissions/AppAbility';
import { ItemErrorService } from 'src/app/shared/services/itemError.service';
import { AddItemService } from './add-item.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface BudgetForm {
  Quantity: number;
  isSingleBudget: boolean;
  budgetList: IBudgetAllocForm[];
  singleBudget: IBudgetAllocForm | null;
}
@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-add-item-page',
  templateUrl: './add-item-page.component.html',
  styleUrls: ['./add-item-page.component.scss'],
})
export class AddItemPageComponent implements OnInit, OnDestroy {
  @Input() currentRoute = ['Purchase Modes'];
  breadCrumbFlow:string[]=['Purchase Modes'];
  expandThis: boolean = true;
  currError: boolean = false;
  itemErrorShow: boolean = false;
  errMsg: string = 'Please correct the errors in the following tabs:<br><b>Price</b><br><ul><li>Please select another currency</li></ul>'
  isRFSEnabled: boolean = false;
  currentPageString: string = 'Add Item';
  activePage: string = 'Add Item';
  formStatus: FormHeaderElement[] = itemStatusPopulator;
  itemList: IItemToRequest[] = [];
  userList: ExtendedKeycloakUser[] = [];
  vendorForm!: Vendor[];
  addItemForm!: FormGroup;
  addItemPriceForm!: FormGroup;
  addCapitalUsageRequirementForm!: FormGroup;
  IsCapitalUsageRequirementEnable: boolean = false;
  budgetAllocationForm: BudgetForm = {
    Quantity: 1,
    budgetList: [],
    isSingleBudget: true,
    singleBudget: null,
  };
  mpNumber: string = '';
  destroy$: Subject<boolean> = new Subject<boolean>();
  form: MyPurchaseForm | null = null;
  itemNo: string | null = null;
  selectedTabIndex: number = 0;
  purchaseType: string = '';
  addOnList: AddOn[] = [];
  isReadOnly: boolean = false;
  formMeetsReadOnlyCriteria = false
  loggedInUser?: UserInformation
  permissionData$: Observable<any>
  itemErrorList: Map<number, string[]>=new Map<number, string[]>(); 
  @HostListener('window:beforeunload', ['$event']) unloadWarning(
    e: BeforeUnloadEvent
  ) {
    //e.preventDefault()
    e.returnValue = true;
    return e;
  }
  private subscription: Subscription | null = null;
  constructor(
    private _fb: FormBuilder,
    private permissionService: PermissionsService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<{ form: MyPurchaseForm, dp: StoreDropdowns, user: UserInformation }>,
    private itemErrorService: ItemErrorService,
    private addItemService:AddItemService
  ) {
    const tabIndex = Number(this.route.snapshot.queryParamMap.get('tab'));
    if (!isNaN(tabIndex)) {
      this.selectedTabIndex = tabIndex
    }
    const previousPageName = sessionStorage.getItem('fromPage');
    if (previousPageName) {
      this.breadCrumbFlow = [previousPageName];
    } 
    this.permissionData$ = permissionService.getService().pipe(takeUntil(this.destroy$))
    this.mpNumber = this.route.snapshot.params['id'];
    this.itemNo = this.route.snapshot.params['itemNo'];
    this.currentPageString = this.route.snapshot.params['itemNo'] ? 'Update Item' : 'Add Item';
    this.activePage = this.route.snapshot.params['itemNo'] ? 'Update Item' : 'Add Item';
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(
      ';'
    )[0] as string;
    this.setHeaderPath(this.purchaseType);
    this.addItemForm = this._fb.group({
      itemId: 1,
      displayItemNumber: 1,
      PartModelNumber: '',
      IsSML: null,
      SMLReasonId: null,
      isCOTS: [null, [Validators.required]],
      isSingleBudget: null, //this is the real value here
      ItemDescription: [null, [Validators.required]],
      PlannedDeliveryDate: [null, [Validators.required]],
      BrandOEMName: null,
      MaterialGroupId: [null, [Validators.required]],
      MaterialSubGroupId: [null, [Validators.required]],
      WorkmanshipId: null,
      CriticalityId: null,
      PurchaseItemId: null,
      BrandOEMNameCustom: '',
    });

    this.addItemPriceForm = this._fb.group({
      UnitOfMeasurement: [{ id: 6, value: 'Each' }, [Validators.required]],
      Quantity: ['1.000', [Validators.required]],
      UnitsPerQuantity: ['1.00', [Validators.required]],
      Currency: [{ id: 'SGD', value: 'SGD' }, [Validators.required]],
      UnitPrice: ['1.00', [Validators.required]],
      ExchangeRate:null
    });

    this.addCapitalUsageRequirementForm = this._fb.group({
      IsAdditionalSpaceRequired:null,
      EstimatedUsageId: ['', [Validators.required]],
      AnnualMaintenanceCost:[0, [Validators.required]],
      IsSupportingNonFundingProject: null,
      SupportingInformation:[null, [Validators.required]],
    })
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.userList = dp.UserList as ExtendedKeycloakUser[];
      });
    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserInformation) => {
        this.loggedInUser = user
        this.setIsReadOnly()
      });
    this.itemErrorList = this.itemErrorService.getItemKeyValue(Number(this.itemNo));
    if (this.itemErrorList) {
      this.errMsg=this.returnErrorMessageInHtml();
      this.itemErrorShow=true;
    }
  }
  
  handleBudgetTypeChange(event: any) {
    let hasCapitalOrCapitalAUC: boolean = false;
    if (!this.budgetAllocationForm.isSingleBudget && this.budgetAllocationForm.budgetList.length > 0) {
      hasCapitalOrCapitalAUC = this.budgetAllocationForm.budgetList.some(budget =>
        !budget.isDeleted && (budget.BudgetType.id === 'Capital' || budget.BudgetType.id === 'Capital AUC')
      );
    }
    if (event == 'Capital' || event == 'Capital AUC' || hasCapitalOrCapitalAUC) {
      this.IsCapitalUsageRequirementEnable = true;
    } else {
      this.IsCapitalUsageRequirementEnable = false;
    }
  }
  ngOnInit(): void {
    window.scroll(0, 0);
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        this.form = form
        this.itemList = form.ItemList;
        this.vendorForm = form.VendorsToSource;
        if (isEqual(form, initialState)) {
          // this.router.navigate(['/rfq', this.mpNumber]);
          this.router.navigate([
            '/purchase/',
            this.purchaseType,
            this.mpNumber,
          ]);
        }
        if (form.ItemList && this.itemNo) {
          this.addOnList = form.ItemList[+this.itemNo - 1]?.AddOnFeature || [];
          let selectedItem = this.itemList.filter((items: any) => items.AddItems.itemId == this.itemNo);
          let budgetFilter = selectedItem[0]?.BudgetAllocation.find(item => (item.BudgetType.value === 'Capital' || item.BudgetType.value === 'Capital AUC'))
          if(budgetFilter){
            this.IsCapitalUsageRequirementEnable = true;
          }
        }
        this.formMeetsReadOnlyCriteria = (form.documentStatusId != 2 && form.documentStatusId != 3 && form.documentStatusId != 6 && form.documentStatusId != 11)
        this.setIsReadOnly()

      });

    if (this.formMeetsReadOnlyCriteria && (this.purchaseType == 'rfq' || this.purchaseType === 'corporatecard')) {
      this.checkForSourcing();
    }
    this.subscription = this.addItemService.removedBudget.subscribe(() => {
      this.handleBudgetTypeChange(null);
    });
  }
  returnErrorMessageInHtml(): string {
    let result = 'Please correct the fields in the following tabs, and then validate at the document level to see the latest changes:';
    Object.entries(this.itemErrorList).forEach(([key, values]) => {
      result += `<br><b>${key}</b><br><ul><li>${values.join('</li><li>')}</ul></li>`;
    });
    return result;
  } 
  setIsReadOnly() {
    if (this.form && this.loggedInUser) {
      this.isReadOnly = isReadOnly(this.form, this.loggedInUser?.userName || '')
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  handleCurrExError(value: boolean) {
    this.currError = value;
  }
  checkForSourcing() {
    const filteredItemList = this.itemList.filter((item: any) => !item.isDeleted && !item.Strikethrough);
    let isCOTS = filteredItemList.every(item => item.AddItems.isCOTS?.value === 'COTS');
    console.log("isCOTS : ", isCOTS);

    let totalPrice = 0;
    if (isCOTS) {
        for (let i = 0; i < filteredItemList.length; i++) {
            totalPrice += (filteredItemList[i].ItemPrice.UnitPrice * filteredItemList[i].ItemPrice.Quantity) / filteredItemList[i].ItemPrice.UnitsPerQuantity;
        }
    }
    //enabling/disabling RFS
    ((isCOTS && totalPrice > 6000) && (( this.purchaseType === 'rfq' && this.form?.generalForm?.reasonForNotUsingRFQ?.value === environment.optForRFQReasonCode) || this.purchaseType === 'corporatecard')) ? this.isRFSEnabled = true : this.isRFSEnabled = false;
    let selectedItem = this.itemList.filter((items: any) => items.AddItems.itemId == this.itemNo);

    this.formStatus = [
      new FormHeaderElement(
        'Item No:',
        this.itemNo ?? '-'
      )
    ]
    if (this.isRFSEnabled) {
      this.formStatus = this.formStatus.concat([
        new FormHeaderElement(
          'Purchasing exec:',
          this.userList.find((user) => user.id == selectedItem[0]?.AddItems?.PurchaseExecutive)
            ?.last_name ?? '-'
        ),
        new FormHeaderElement(
          'Sourcing status:',
          SourcingStatus.find((status) => {
            return status.SourcingStatusId == selectedItem[0]?.AddItems?.SourcingStatusId
          })?.name ?? (selectedItem[0]?.AddItems?.TaggedVendors ? 'Potential vendor identified' : ''),
        )
      ])
    }
  }

  returnToRFQ = (args: any): void => {
    this.router.navigate([
      '/purchase/',
      this.purchaseType,
      this.mpNumber,
      { edited: true },
    ]);
  };

  saveFormAndReturnToRFQ = (): void => {
    let itemToUpdate = this.itemList.find(item => item.AddItems.itemId === this.addItemForm.value.itemId)
    let newBudgetList: IBudgetAllocForm[] = itemToUpdate?.BudgetAllocation.map((item) => ({
      ...item,
      isDeleted: true,
    })) || [];
    let deletedBudgets = newBudgetList.filter(x => x.BudgetItemId !== null)
    if (this.isReadOnly) {
      this.router.navigate([
        '/purchase/',
        this.purchaseType,
        this.mpNumber,
        { edited: true },
      ]);
    }
    let selectedItem = this.itemList.filter((items: any) => items.AddItems.itemId == this.itemNo);
    if (
      this.budgetAllocationForm.isSingleBudget &&
      this.budgetAllocationForm.singleBudget
    ) {
      if (
        this.budgetAllocationForm.singleBudget.BudgetType.id !==
        (itemToUpdate?.BudgetAllocation && itemToUpdate?.BudgetAllocation?.[0]?.BudgetType?.id)
      ) {
        this.budgetAllocationForm.singleBudget.Quantity =
          this.addItemPriceForm.controls['Quantity'].getRawValue();
        newBudgetList?.push({
          ...this.budgetAllocationForm.singleBudget,
          PurchaseItemNo: this.addItemForm.value.itemId,
          displayPurchaseItemNumber: this.addItemForm.value.displayItemNumber,
        });
      } else {
        this.budgetAllocationForm.singleBudget.Quantity =
          this.addItemPriceForm.controls['Quantity'].getRawValue();
        let newBudget = {
          ...this.budgetAllocationForm.singleBudget,
          PurchaseItemNo: this.addItemForm.value.itemId,
          displayPurchaseItemNumber: this.addItemForm.value.displayItemNumber,
          BudgetItemId:null,
        }
        newBudgetList.splice(0, 0, newBudget)
      }
    }
    let itemToAdd: IItemToRequest = {
      AddItems: {
        ...this.addItemForm.value,
        PlannedDeliveryDate: this.addItemForm.controls['PlannedDeliveryDate']?.getRawValue()?.toDate() || null,
        isSingleBudget: this.budgetAllocationForm.isSingleBudget,
        ReferenceId: selectedItem[0]?.AddItems?.ReferenceId,
        IsExemptedAOR: this.updateExceptionAOR(this.addItemForm.value?.MaterialSubGroupId?.IsExemptedAOR),
        SourcingStatusId: selectedItem[0]?.AddItems?.SourcingStatusId,
        TaggedVendors: selectedItem[0]?.AddItems?.TaggedVendors,
        AnnualMaintenanceCost: this.addCapitalUsageRequirementForm.controls['AnnualMaintenanceCost'].getRawValue(),
        EstimatedUsageId: this.addCapitalUsageRequirementForm.controls['EstimatedUsageId'].getRawValue(),
        IsSupportingNonFundingProject: this.addCapitalUsageRequirementForm.controls['IsSupportingNonFundingProject'].getRawValue(),
        SupportingInformation: this.addCapitalUsageRequirementForm.controls['SupportingInformation'].getRawValue(),
        IsAdditionalSpaceRequired: this.addCapitalUsageRequirementForm.controls['IsAdditionalSpaceRequired'].getRawValue(),
      },
      ItemPrice: this.addItemPriceForm.value,
      BudgetAllocation: (this.budgetAllocationForm.isSingleBudget && this.budgetAllocationForm.singleBudget)
        ? newBudgetList : this.addDeletedBudgets(this.updateItemPurchaseNoForBudgetList(this.budgetAllocationForm.budgetList), deletedBudgets),
      isDeleted: false,
      AddOnFeature: this.addOnList.map((item: AddOn) => {
        return { ...item, isDeleted: item.isDeleted || false, itemId: this.addItemForm.value.itemId, displayItemNumber: this.addItemForm.value.displayItemNumber, MPDocumentNumber: this.mpNumber };
      }),
      Strikethrough: false
    };
    if (itemToUpdate) itemToAdd.BudgetAllocation = this.addSpaceRequirementToItemBudgetAllocations(itemToUpdate?.BudgetAllocation, itemToAdd.BudgetAllocation)
    console.log('item to be added', itemToAdd);
    console.log('item to be added budget allocation', this.budgetAllocationForm);
    console.log('item to be updated', itemToUpdate);
    console.log(this.itemNo);
    if (!this.itemNo) {
      this.store.dispatch(addItemtoMyPurchase({ form: itemToAdd }));
    } else {
      this.store.dispatch(updateItemForm({ form: itemToAdd }));
    }
    this.router.navigate([
      '/purchase/',
      this.purchaseType,
      this.mpNumber,
      { edited: true },
    ]);
  };

  updateExceptionAOR(exceptionAOR: any[]) {
    return exceptionAOR;
  }
  scrollTop(): void {
    window.scrollTo(0, 0);
  }
  addDeletedBudgets(budgetList: IBudgetAllocForm[], deletedBudgets: IBudgetAllocForm[]) {
    let result = budgetList.slice()
    for (const deletedBudget of deletedBudgets) {
      if (deletedBudget.BudgetItemId !== null) {
        let budget = budgetList.find(x => x.BudgetItemId == deletedBudget.BudgetItemId)
        if (!budget) result.push(deletedBudget)
      }
    }
    return result
  }
  addSpaceRequirementToItemBudgetAllocations(oldBudgetAllocations: IBudgetAllocForm[], newBudgetAllocations: IBudgetAllocForm[]) {
    let finalResults: IBudgetAllocForm[] = []
    for (const newRecord of newBudgetAllocations) {
      if (!newRecord.isDeleted && (newRecord.BudgetType.id == 'Capital' || newRecord.BudgetType.id == 'Capital AUC') && (newRecord.ProjectBudget || newRecord.FundCentre)) {
        let oldRecord: any;
        if (newRecord.FundCentre)
          oldRecord = oldBudgetAllocations.find(x => _.isEqual(x.BudgetType, newRecord.BudgetType) && _.isEqual(newRecord.FundCentre, x.FundCentre))
        if (newRecord.ProjectBudget)
          oldRecord = oldBudgetAllocations.find(x => _.isEqual(x.BudgetType, newRecord.BudgetType) && _.isEqual(newRecord.ProjectBudget, x.ProjectBudget))
        if (oldRecord) {
          let finalRecord: IBudgetAllocForm = {
            ...newRecord
          }
          finalResults.push(finalRecord)
        }
        else finalResults.push(newRecord)
      }
      else finalResults.push(newRecord)
    }
    return finalResults
  }
  updateBudgetForm(event: any) {
    this.budgetAllocationForm = structuredClone(event);
  }

  updateItemPurchaseNoForBudgetList(budgetList: IBudgetAllocForm[]) {
    let newList: IBudgetAllocForm[] = [];

    for (const budget of budgetList) {
      newList.push({
        ...budget,
        PurchaseItemNo: this.addItemForm.value.itemId,
        displayPurchaseItemNumber: this.addItemForm.value.displayItemNumber,
      });
    }
    return newList;
  }
  nextSection(): void {
    if (this.selectedTabIndex < 3) {
      this.selectedTabIndex += 1;
    }
  }
  previousSection(): void {
    if (this.selectedTabIndex != 0) {
      this.selectedTabIndex -= 1;
    }
  }

  getAddOnData(form: AddOn) {
    const newData = [...this.addOnList];
    const index = this.addOnList.findIndex(
      (e: AddOn) => e.AddOnTypeId === form.AddOnTypeId && !e.Strikethrough && e.itemId === form.itemId
    );
    if (index > -1) {
      newData[index] = form;
    } else {
      newData.push(form);
    }
    this.addOnList = newData.filter(x => x.PurchaseItemId !== null || !x.isDeleted)
  }

  async buttonHandler($event: any) {
    switch ($event.actionType as string) {
      case 'add-item': {
        if (this.currError) {
          return;
        }
        else {
          this.saveFormAndReturnToRFQ()
        }
        break
      }
      default:
        // do nothing
        break;
    }
  }

  setHeaderPath(purchaseType: string) {
    if (this.mpNumber && this.mpNumber != 'draft') {
      this.breadCrumbFlow.push(this.mpNumber);
    } else {
      switch (purchaseType) {
        case 'rfq':
          this.currentRoute.push('Request For Quotation');
          this.breadCrumbFlow.push('Request For Quotation');
          break;
        case 'tender':
          this.currentRoute.push('Tender');
          this.breadCrumbFlow.push('Tender');
          break;
        case 'corporatecard':
          this.currentRoute.push('Corporate Credit Card');
          this.breadCrumbFlow.push('Corporate Credit Card');
          break;
        case 'dc':
          this.currentRoute.push('Direct Contracting');
          this.breadCrumbFlow.push('Direct Contracting');
          break;
        case 'permissiblecoveringpurchaseorder':
          this.currentRoute.push('Permissible Reasons');
          this.breadCrumbFlow.push('Permissible Reasons');
          break;
      }
    }
  }

  public get AbilityField(): typeof AbilityField {
    return AbilityField
  }
}
